// extracted by mini-css-extract-plugin
module.exports = {"joyLink":"SignIn_joyLink__12zXb"};